import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess22001Status: 'idle',
    startProcess22001Error: undefined as any,
    loadUserParamsProcess22001Status: 'idle',
    loadUserParamsProcess22001Error: undefined as any,

    process22001List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess22001 = createAsyncThunk('process22001Slice/startProcess22001', async ({ process22001 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess22001/`,
        prepareData(process22001),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess22001Status } = getState().process22001Slice
        return startProcess22001Status !== 'pending'
    }
})

export const loadUserParamsProcess22001 = createAsyncThunk('process22001Slice/loadUserParamsProcess22001', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess22001/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess22001Status } = getState().process22001Slice
        return loadUserParamsProcess22001Status !== 'pending'
    }
})

const Process22001Slice = createSlice({
    name: 'process22001Slice',
    initialState,
    reducers: {
        resetstartProcess22001: (state) => {
            state.job = undefined
            state.startProcess22001Error = undefined
        },
        resetstartProcess22001Error: (state) => {
            state.startProcess22001Error = undefined
        },
        resetloadUserParamsProcess22001: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess22001Error = undefined
        },
        resetloadUserParamsProcess22001Error: (state) => {
            state.loadUserParamsProcess22001Error = undefined
        },
        removeFromProcess22001ListById: (state, action) => {
            state.process22001List = state.process22001List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess22001ListByIds: (state, action) => {
            state.process22001List = state.process22001List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process22001List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess22001Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process22001List = []
            state.startProcess22001Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess22001.pending, (state) => {
            state.startProcess22001Status = 'pending'
            state.startProcess22001Error = undefined
        })
        builder.addCase(startProcess22001.fulfilled, (state, action) => {
            state.startProcess22001Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess22001.rejected, (state, action) => {
            state.startProcess22001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess22001Error = action.error.message
            } else {
                state.startProcess22001Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess22001.pending, (state) => {
            state.loadUserParamsProcess22001Status = 'pending'
            state.loadUserParamsProcess22001Error = undefined
        })
        builder.addCase(loadUserParamsProcess22001.fulfilled, (state, action) => {
            state.loadUserParamsProcess22001Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess22001.rejected, (state, action) => {
            state.loadUserParamsProcess22001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess22001Error = action.error.message
            } else {
                state.loadUserParamsProcess22001Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess22001,
    resetstartProcess22001Error,
    resetloadUserParamsProcess22001,
    resetloadUserParamsProcess22001Error,
    removeFromProcess22001ListById,
    removeFromProcess22001ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process22001Slice.actions
export default Process22001Slice.reducer
